import React, { useEffect, useMemo } from 'react';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { observer } from 'mobx-react-lite';
import { useParams } from 'react-router-dom';
import PageInFlowNoSidebarLayout from 'components/common/general/layouts/PageInFlowNoSidebarLayout';
import { redirectToRoute } from 'routes/redirectToRoute';
import { RouteV2Id } from 'routes/routesConfigV2';
import {
  OverrideQuotedRatesPageStore,
  OverrideQuotedRatesPageStoreContext,
  useOverrideQuotedRatesPageStore,
} from 'store/modules/override-rates/override-quoted-rates/pageStore';
import { OverrideQuotedRatesContent } from 'components/override-quoted-rates';

interface PageParams {
  groupId: string;
  periodId: string;
  cartId: string;
  portfolioId: string;
  productLineId: ProductLineId;
  bcIndex: string;
}

const PageContent: React.FC = observer(() => {
  const { isInitialDataLoading, isActionLoading, getInitialData, returnBack, canOverrideRates, overrideRates } =
    useOverrideQuotedRatesPageStore();

  const { periodId, cartId, groupId, portfolioId, productLineId, bcIndex } = useParams<{
    groupId: string;
    periodId: string;
    cartId: string;
    portfolioId: string;
    productLineId: ProductLineId;
    bcIndex: string;
  }>();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <PageInFlowNoSidebarLayout
      contentWidth="standard"
      isActionLoading={isActionLoading}
      isInitialLoading={isInitialDataLoading}
      domainParams={{ groupId, periodId, cartId, portfolioId, productLineId, bcIndex }}
      pageId={RouteV2Id.QUOTE_OVERRIDE_RATES_PLAN}
      pageHeader={{ subtitleMaxWidth: '53rem', onBackButtonClick: returnBack }}
      pageFooter={{
        completeButtonText: 'Override Rates',
        disableCompleteButton: !canOverrideRates,
        onBack: returnBack,
        onComplete: overrideRates,
      }}
    >
      <OverrideQuotedRatesContent />
    </PageInFlowNoSidebarLayout>
  );
});

const QuoteOverrideRatesPlanPage: React.FC = () => {
  const { groupId, periodId, cartId, portfolioId, productLineId, bcIndex } = useParams<PageParams>();
  const pageStore = useMemo(
    () =>
      new OverrideQuotedRatesPageStore(
        {
          groupId,
          periodId,
          cartId,
          portfolioId: decodeURIComponent(portfolioId),
          productLineId,
          bcIndex: Number(bcIndex),
        },
        (): void => {
          redirectToRoute(RouteV2Id.QUOTE_OVERRIDE_RATES, { groupId, periodId, cartId });
        },
      ),
    [],
  );

  return (
    <OverrideQuotedRatesPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </OverrideQuotedRatesPageStoreContext.Provider>
  );
};

export default QuoteOverrideRatesPlanPage;
